// DBTable "proizvod"
export enum Product {
  Package = 1,
  Document = 2,
  PersonalDelivery = 3,
  CodPayment = 4,
  OversizePackage = 5,
  ReturnDocument = 6,
  ReplacementShipment = 7,
  HybridMall = 8,
}
